import { installChunkReload } from './utils/chunkReload';


installChunkReload();

import('./bootstrap');
